module.exports = __webpack_public_path__ + "img/picture-other-services-desktop.e6069ca9.jpg";